// Autocompletado de Código Postal para Comunas de Chile (RM)
// Mi Flor - miflor.cl
// Códigos postales oficiales actualizados

(function() {
  'use strict';

  // Tabla de comunas y códigos postales de la Región Metropolitana
  // Fuente: Datos oficiales de Mi Flor
  const comunaCodigoPostal = {
    // Normalizado sin tildes, en minúsculas
    'santiago': '8320000',
    'providencia': '7500000',
    'nunoa': '7750000',
    'ñuñoa': '7750000',
    'independencia': '8380000',
    'las condes': '7550000',
    'estacion central': '9160000',
    'estación central': '9160000',
    'macul': '7810000',
    'quinta normal': '8500000',
    'recoleta': '8420000',
    'lo prado': '8980000',
    'san miguel': '8900000',
    'la reina': '7850000',
    'conchali': '8540000',
    'conchalí': '8540000',
    'cerro navia': '9080000',
    'vitacura': '7630000',
    'san joaquin': '8940000',
    'san joaquín': '8940000',
    'la granja': '8780000',
    'san ramon': '8860000',
    'san ramón': '8860000',
    'huechuraba': '8580000',
    'penalolen': '7910000',
    'peñalolén': '7910000',
    'renca': '8640000',
    'pedro aguirre cerda': '8460000',
    'p.a.c.': '8460000',
    'pac': '8460000',
    'cerrillos': '9200000',
    'pudahuel': '9020000',
    'la cisterna': '7970000',
    'lo espejo': '9120000',
    'el bosque': '8010000',
    'maipu': '9250000',
    'maipú': '9250000',
    'quilicura': '8700000',
    'la florida': '8240000',
    'nos': '9380000',
    'ños': '9380000',
    'el monte': '9810000',
    'puente alto': '8150000',
    'san bernardo': '8050000',
    'la pintana': '8820000',
    'padre hurtado': '9710000',
    'pirque': '9480000',
    'lo barnechea': '7690000',
    'talagante': '9670000',
    'tiltil': '9420000',
    'melipilla': '9580000',
    'buin': '9500000',
    'calera de tango': '9560000',
    'paine': '9540000',
    'chicureo': '9340000',
    'penaflor': '9750000',
    'peñaflor': '9750000',
    'colina': '9340000',
    'lampa': '9380000',
    'batuco': '9320000',
    'malloco': '9760842',
    'el volcan': '9460000',
    'el volcán': '9460000',
    'san jose de maipo': '9460000',
    'san josé de maipo': '9460000',
    'rapel': '3970000'
  };

  // Función para normalizar texto (quitar tildes, convertir a minúsculas)
  function normalizarTexto(texto) {
    return texto
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  // Función para buscar el código postal
  function buscarCodigoPostal(ciudad) {
    const ciudadNormalizada = normalizarTexto(ciudad);
    return comunaCodigoPostal[ciudadNormalizada] || null;
  }

  // Función principal de autocompletado
  function autocompletarCodigoPostal() {
    // Intentar múltiples selectores para encontrar los campos
    const selectorCiudad = [
      'input[name="checkout[shipping_address][city]"]',
      'input[name="address[city]"]',
      '#checkout_shipping_address_city',
      '[data-address-field="city"]',
      'input[autocomplete="address-level2"]',
      'input[placeholder*="Ciudad"]',
      'input[placeholder*="Comuna"]',
      '#AddressCity_new',
      '#address_city'
    ];

    const selectorCodigoPostal = [
      'input[name="checkout[shipping_address][zip]"]',
      'input[name="address[zip]"]',
      '#checkout_shipping_address_zip',
      '[data-address-field="zip"]',
      'input[autocomplete="postal-code"]',
      'input[placeholder*="Código postal"]',
      '#AddressZip_new',
      '#address_zip'
    ];

    let campoCiudad = null;
    let campoCodigoPostal = null;

    // Buscar campo de ciudad
    for (let selector of selectorCiudad) {
      campoCiudad = document.querySelector(selector);
      if (campoCiudad) {
        console.log('✅ Campo ciudad encontrado con selector:', selector);
        break;
      }
    }

    // Buscar campo de código postal
    for (let selector of selectorCodigoPostal) {
      campoCodigoPostal = document.querySelector(selector);
      if (campoCodigoPostal) {
        console.log('✅ Campo código postal encontrado con selector:', selector);
        break;
      }
    }

    if (campoCiudad && campoCodigoPostal) {
      console.log('✅ Autocompletado de código postal activado');

      // Función para actualizar el código postal
      function actualizarCodigoPostal() {
        const ciudadIngresada = campoCiudad.value;
        const codigoPostal = buscarCodigoPostal(ciudadIngresada);

        if (codigoPostal) {
          campoCodigoPostal.value = codigoPostal;
          
          // Disparar eventos para que Shopify detecte el cambio
          campoCodigoPostal.dispatchEvent(new Event('change', { bubbles: true }));
          campoCodigoPostal.dispatchEvent(new Event('input', { bubbles: true }));
          campoCodigoPostal.dispatchEvent(new Event('blur', { bubbles: true }));
          
          console.log('✅ Código postal autocompletado:', codigoPostal, 'para', ciudadIngresada);
        } else {
          console.log('⚠️ No se encontró código postal para:', ciudadIngresada);
        }
      }

      // Escuchar cuando el usuario sale del campo (blur)
      campoCiudad.addEventListener('blur', actualizarCodigoPostal);

      // También escuchar mientras escribe (con delay para no saturar)
      let timeout;
      campoCiudad.addEventListener('input', function() {
        clearTimeout(timeout);
        timeout = setTimeout(actualizarCodigoPostal, 800);
      });

      // Escuchar el evento 'change' también
      campoCiudad.addEventListener('change', actualizarCodigoPostal);

    } else {
      console.log('⚠️ No se encontraron los campos de ciudad o código postal');
      console.log('Campo ciudad:', campoCiudad ? 'Encontrado' : 'No encontrado');
      console.log('Campo código postal:', campoCodigoPostal ? 'Encontrado' : 'No encontrado');
    }
  }

  // Ejecutar cuando el DOM esté listo
  function inicializar() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autocompletarCodigoPostal);
    } else {
      autocompletarCodigoPostal();
    }
  }

  // Inicializar
  inicializar();

  // Re-ejecutar en cambios de página (para SPAs y checkout dinámico)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', autocompletarCodigoPostal);
  }

  // Intentar re-ejecutar después de un delay (para checkouts que cargan dinámicamente)
  setTimeout(autocompletarCodigoPostal, 2000);
  setTimeout(autocompletarCodigoPostal, 4000);

})();
